import { render } from "./BtnReenviarEmail.vue?vue&type=template&id=e8513d98"
import script from "./BtnReenviarEmail.vue?vue&type=script&lang=js"
export * from "./BtnReenviarEmail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__